import React, { useEffect } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { useNavigate } from 'react-router-dom';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import { Typography, Grid, Box, Button } from '@mui/material';

const Trayectorias = ({ }) => {

    const { trackPageView } = useMatomo();

    useEffect(() => {
        document.title = "Suma y Sigue | Trayectorias formativas";
        trackPageView();
    }, []);

    const navigate = useNavigate();

    return (
        <Grid style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header current={"trayectorias"} />
            <Grid
                p={"0 20px"}
                component="div"
                sx={{
                flexGrow: 1,
                m: '30px auto',
                maxWidth: '940px',
                width: '100%',
                }}
            >
                <Typography variant='subtitle' fontWeight={"bold"} m={"20px 0"} textAlign={"center"}>
                    TRAYECTORIAS FORMATIVAS
                </Typography>
                <Typography variant='p' m={"20px 0"}>
                    Las trayectorias formativas del Programa <i>Suma y Sigue</i> buscan ofrecer a los docentes una secuencia 
                    de cursos que les permita especializarse en la enseñanza de la matemática en un nivel o ciclo escolar 
                    específico, considerando un eje temático particular. 
                </Typography>
                
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Trayectoria Formativa de Especialización para la Enseñanza de los Números y
                    las Operaciones en Primer Ciclo Básico
                </Typography>
                <Grid container spacing={2} alignItems={"center"} justifyContent={"center"}>
                    <Grid item xs={12} md={8}>
                        <Typography variant='p'>
                            Se enfoca en el desarrollo de
                            conocimientos especializados para enseñar contenidos
                            relacionados con la enseñanza de los números y operaciones
                            desde 1º a 4º básico.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center" }}>
                        <Button variant="red" onClick={() => navigate("/trayectorias/num_c1")}>Ver trayectoria</Button>
                    </Grid>
                </Grid>
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Trayectoria Formativa para la Enseñanza de la Geometría y Medición en el
                    Primer Ciclo Básico
                </Typography>
                <Grid container spacing={2} alignItems={"center"} justifyContent={"center"}>
                    <Grid item xs={12} md={8}>
                        <Typography variant='p'>
                            Se enfoca en el desarrollo de
                            conocimientos especializados para enseñar contenidos
                            relacionados con la enseñanza de la geometría y medición
                            desde 1º a 4º básico.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center" }}>
                        <Button variant="red" onClick={() => navigate("/trayectorias/geo_c1")}>Ver trayectoria</Button>
                    </Grid>
                </Grid>
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Trayectoria Formativa para la Enseñanza de los Números y Álgebra en el
                    Segundo Ciclo Básico
                </Typography>
                <Grid container spacing={2} alignItems={"center"} justifyContent={"center"}>
                    <Grid item xs={12} md={8}>
                        <Typography variant='p'>
                            Se enfoca en el desarrollo de
                            conocimientos especializados para enseñar contenidos
                            relacionados con la enseñanza de fracciones y sus
                            representaciones, trabajar con los números racionales y
                            desarrollar el pensamiento algebraico de segundo ciclo básico.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center" }}>
                        <Button variant="red" onClick={() => navigate("/trayectorias/num_c2")}>Ver trayectoria</Button>
                    </Grid>
                </Grid>
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Trayectoria Formativa para la Enseñanza de la Estadística y Probabilidades
                    en el Segundo Ciclo Básico
                </Typography>
                <Grid container spacing={2} alignItems={"center"} justifyContent={"center"}>
                    <Grid item xs={12} md={8}>
                        <Typography variant='p'>
                            Se enfoca en el desarrollo de
                            conocimientos especializados para enseñar contenidos
                            relacionados con la enseñanza del desarrollo del pensamiento
                            estadístico, así como con la incerteza y la probabilidad.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center" }}>
                        <Button variant="red" onClick={() => navigate("/trayectorias/est_c2")}>Ver trayectoria</Button>
                    </Grid>
                </Grid>
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Trayectoria de Especialización para la Enseñanza de la Matemática en 7° y 8°
                    Básico
                </Typography>
                <Grid container spacing={2} alignItems={"center"} justifyContent={"center"}>
                    <Grid item xs={12} md={8}>
                        <Typography variant='p'>
                            Se enfoca en el desarrollo de
                            conocimientos especializados para enseñar contenidos
                            relacionados con la enseñanza de los números y operaciones
                            desde 1º a 4º básico.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center" }}>
                        <Button variant="red" onClick={() => navigate("/trayectorias/mat_78")}>Ver trayectoria</Button>
                    </Grid>
                </Grid>
                <Box textAlign={"center"} mt={"40px"}>
                    <Typography variant='p' textAlign={"center"} mb={"20px"}>
                        ¿Necesitas ayuda para elegir la trayectoria formativa que más se ajusta a tus necesidades?
                    </Typography>
                    <Button variant="red" onClick={() => navigate("/trayectorias/formulario")}>Ir al formulario</Button>
                </Box>
            </Grid>
            <Footer />
        </Grid>
    );

};

export default Trayectorias;